export const appsAppGroupIdChartsDailyPurchasesByPurchaseNames =
  "/apps/:app_group_id/charts/daily_purchases_by_purchase_names";
